export default "__VITE_ASSET__Bcqi1RlW__"